import(/* webpackMode: "eager", webpackExports: ["HomeFAQ"] */ "/home/pi/prod/strawman/apps/web/components/faq/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FinalCTA"] */ "/home/pi/prod/strawman/apps/web/components/final-cta/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/pi/prod/strawman/apps/web/styles/home.css");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/pi/prod/strawman/node_modules/.pnpm/next@15.4.4_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/app-dir/link.js");
